
<section class="hero-section">
    <div class="hero-banner-container">
        <button class="hero-arrow left-arrow" aria-label="Previous" (click)="showPrev()">&#8592;</button>
        <img [src]="bannerImages[currentIndex].src" alt="Banner" class="hero-banner-img" />
        <div class="hero-banner-text">{{ bannerImages[currentIndex].text }}</div>
        <div class="hero-banner-subtext">{{ bannerImages[currentIndex].subtext }}</div>
        <button class="hero-banner-cta" (click)="goToContact()">{{ bannerImages[currentIndex].btnText }}</button>
        <button class="hero-arrow right-arrow" aria-label="Next" (click)="showNext()">&#8594;</button>
        <div class="hero-banner-dots">
            <span *ngFor="let img of bannerImages; let i = index" class="dot" [class.active]="i === currentIndex"
                (click)="goToImage(i)"></span>
        </div>
    </div>
</section>


<section class="enterprise-offerings">
    <div class="offerings-content">
        <div class="enterprise-heading">
            <h1 style="font-size: 32px;">Apple for Business</h1>
        </div>
        <div class="enterprise-details">
            <p class="text-left" style="font-size: 18px; font-weight: 500; line-height: 1.5;">Experience enterprise
                solutions with Superior Digital. We specialise in delivering expert-driven
                technology, consulting, support services, and training that empower businesses to unlock their full
                creative and productive potential.</p>
          
        </div>
    </div>
</section>

<section class="card-section" id="enterprise-solutions">
    <div class="container">
        <div class="row" style="margin-left: 0 !important;">
            <div class="col-lg-12 col-md-12 mb-4">
                <div class="card bg-image">
                    <div class="card-content"
                        style="display: flex; flex-direction: row; align-items: center; justify-content: center; text-align: left; gap: 10rem; background-color: #fff !important; padding: 0 !important">
                        <div class="mac-iphone-image">
                            <img src="assets/images/mac-iphone-together.png" alt="Mac and iPhone Better Together"
                                class="mac-iphone-image1">
                        </div>
                        <div class="mac-dev-section">
                            <div class="mac-iphone-content">
                                <h2>
                                    Mac + iPhone <br>
                                    <span class="better-together-bg"><i style="background-color: #00ff00;">BETTER
                                            <br>TOGETHER</i></span>
                                </h2>

                                <p style="color: #000;">Copy and paste, sync edits and continue <br>conversations
                                    between Mac and iPhone.</p>
                            </div>
                            <div class="cta-section-mac">
                                <a href="/macdoes" class="cta-button animated-tco-btn">Learn More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="hero-overlay-section" id="apple-products-mac">
    <div class="overlay-content">
        <div class="container">
            <div class="section-title">
                <!-- <span style="font-size: 1.2rem; font-weight: 500;">What We Offer</span> -->
                <h2 class="section-title" style="color: #fff;">Apple Products</h2>
                <p class="section-description" style="margin-bottom: 0;">Discover Our Latest Apple Devices.</p>
                <p class="section-description">Explore our range of Apple products designed to enhance your digital
                    experience with
                    cutting-edge technology and innovative features.</p>
            </div>
            <div class="row cards-container">
                <div class="col-lg-4 col-md-6 mb-4" id="apple-products-mac">
                    <div class="feature-card"
                        style="background: url('/assets/images/mac1.jpg') center center/cover no-repeat; position: relative;">
                        <!-- background: linear-gradient(135deg, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.7) 100%); -->
                        <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;"></div>
                        <div class="card-icon" style="position: relative; z-index: 2;">
                            <h3 style="color: #fff;">Mac</h3>
                        </div>
                        <div class="product-links" style="position: relative; z-index: 2;">
                            <ul
                                style="list-style-type: none; margin: 0 20px; padding: 0; gap: 10px; align-items: center;">
                                <li><a href="/macstudio"
                                        style="color: #fff; text-decoration: none; transition: all 0.3s ease; display: block; padding: 0.5rem 0; border-bottom: 1px solid rgba(255,255,255,0.1);">Mac
                                        Studio</a></li>
                                <li><a href="/MBA15"
                                        style="color: #fff; text-decoration: none; transition: all 0.3s ease; display: block; padding: 0.5rem 0; border-bottom: 1px solid rgba(255,255,255,0.1);">Macbook
                                        Air</a></li>
                                <li><a href="/MBP1416"
                                        style="color: #fff; text-decoration: none; transition: all 0.3s ease; display: block; padding: 0.5rem 0;">Macbook
                                        Pro 14" & 16"</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 mb-4" id="apple-products-iphone">
                    <div class="feature-card"
                        style="background: url('/assets/images/iphone1.jpg') center center/cover no-repeat; position: relative;">
                        <!-- background: linear-gradient(135deg, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.7) 100%); -->
                        <div
                            style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background:linear-gradient(135deg, rgb(39 38 38 / 90%) 0%, rgba(0, 0, 0, 0.7) 100%); border-radius: 15px;">
                        </div>
                        <div class="card-icon" style="position: relative; z-index: 2;">
                            <h3 style="color: #fff;">iPhone</h3>
                        </div>
                        <div class="product-links" style="position: relative; z-index: 2;">
                            <ul
                                style="list-style-type: none; margin: 0 20px; padding: 0; gap: 10px; align-items: center;">
                                <li><a href="/iphone-16pro"
                                        style="color: #fff; text-decoration: none; transition: all 0.3s ease; display: block; padding: 0.5rem 0; border-bottom: 1px solid rgba(255,255,255,0.1);">iPhone
                                        16 Pro</a></li>
                                <li><a href="/iPhone16"
                                        style="color: #fff; text-decoration: none; transition: all 0.3s ease; display: block; padding: 0.5rem 0; border-bottom: 1px solid rgba(255,255,255,0.1);">iPhone
                                        16</a></li>
                                <li><a href="/iphone-16e"
                                        style="color: #fff; text-decoration: none; transition: all 0.3s ease; display: block; padding: 0.5rem 0; border-bottom: 1px solid rgba(255,255,255,0.1);">iPhone
                                        16e</a></li>
                                <li><a href="/iPhone15Pro"
                                        style="color: #fff; text-decoration: none; transition: all 0.3s ease; display: block; padding: 0.5rem 0; border-bottom: 1px solid rgba(255,255,255,0.1);">iPhone
                                        15 Pro</a></li>
                                <li><a href="/iPhone15"
                                        style="color: #fff; text-decoration: none; transition: all 0.3s ease; display: block; padding: 0.5rem 0; ">iPhone
                                        15</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 mb-4" id="apple-products-ipad">
                    <div class="feature-card"
                        style="background: url('/assets/images/ipad1.jpg') center center/cover no-repeat; position: relative;">
                        <!-- background: linear-gradient(135deg, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.7) 100%); -->
                        <div
                            style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;  background:linear-gradient(135deg, rgb(39 38 38 / 90%) 0%, rgba(0, 0, 0, 0.7) 100%); border-radius: 15px;">
                        </div>
                        <div class="card-icon" style="position: relative; z-index: 2;">
                            <h3 style="color: #fff;">iPad</h3>
                        </div>
                        <div class="product-links" style="position: relative; z-index: 2;">
                            <ul
                                style="list-style-type: none; margin: 0 20px; padding: 0; gap: 10px; align-items: center;">
                                <li><a style="color: #fff; text-decoration: none; transition: all 0.3s ease; display: block; padding: 0.5rem 0; border-bottom: 1px solid rgba(255,255,255,0.1);"
                                        href="/iPadPro">iPad Pro</a></li>
                                <li><a style="color: #fff; text-decoration: none; transition: all 0.3s ease; display: block; padding: 0.5rem 0; border-bottom: 1px solid rgba(255,255,255,0.1);"
                                        href="/iPadAir">iPad Air</a></li>
                                <li><a style="color: #fff; text-decoration: none; transition: all 0.3s ease; display: block; padding: 0.5rem 0;"
                                        href="/iPad10">iPad 10th Generation</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 mb-4" id="apple-products-watch">
                    <div class="feature-card"
                        style="background: url('/assets/images/watch1.jpg') center center/cover no-repeat; position: relative;">
                        <!-- background: linear-gradient(135deg, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.7) 100%); -->
                        <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;"></div>
                        <div class="card-icon" style="position: relative; width: 100%;">
                            <h3 style="color: #fff;">Apple Watch</h3>
                        </div>
                        <div class="product-links" style="position: relative; z-index: 2;">
                            <ul
                                style="list-style-type: none; margin: 0 20px; padding: 0; gap: 10px; align-items: center;">
                                <li></li>
                                <li></li>
                                <li></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 mb-4" id="apple-products-business">
                    <div class="card text-white">
                        <div class="card-body" style="padding: 20px; background-color: #64666d6b;border-radius: 5px;">
                            <div class="icon-title-row"
                                style="display: flex; align-items: center; gap: 1rem; margin-bottom: 1rem;">
                                <div class="icon">
                                    <img src="assets/images/applebusiness.svg" alt="Apple Business Manager"
                                        style="width: 100px;">
                                </div>
                                <h4 class="card-title" style="margin-bottom: 0;color: #000;">Apple Business Manager
                                </h4>
                            </div>
                            <p class="card-text">Streamline device deployment and app distribution and establish
                                managed
                                Apple IDs for all staff members in a single location.</p>
                            <a href="/apple-business" class="text-danger">Learn More</a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 mb-4" id="apple-products-applecare">
                    <div class="card text-white">
                        <div class="card-body" style="padding: 20px; background-color: #64666d6b;border-radius: 5px;">
                            <div class="icon-title-row"
                                style="display: flex; align-items: center; gap: 1rem; margin-bottom: 1rem;">
                                <div class="icon">
                                    <img src="assets/images/applecare.png" alt="AppleCare for Enterprise"
                                        style="width: 90px;">
                                </div>
                                <h4 class="card-title" style="margin-bottom: 0;color: #000;">AppleCare for
                                    Enterprise</h4>
                            </div>
                            <p class="card-text">Help desk support, OS support, and enterprise support solutions.
                                The
                                best
                                support and care from the experts who know Apple products best.</p>
                            <a href="/applecare" class="text-danger">Learn More</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="card-section" id="enterprise-solutions">
    <div class="container">
        <div class="row" style="margin-left: 0 !important;">
            <div class="col-lg-12 col-md-12 mb-4" id="getting-started-with-mac">
                <div class="card bg-image" style="background-image: url('assets/images/getting_started_with_Mac.png');">
                    <div class="card-content"
                        style="display: flex; flex-direction: row; align-items: center; justify-content: center; text-align: left; gap: 2rem;">
                        <h3
                            style="margin-bottom: 0; min-width: 160px; font-size: 2.2rem !important; text-align: center;">
                            Getting Started with Mac</h3>
                        <div class="mac-dev-section">
                            <div class="container">
                                <div class="mac-dev-grid">
                                    <div class="mac-dev-col">
                                        <!-- <h3>Special Benefits for Startups</h3> -->
                                        <ul>
                                            <li>⁠Evaluation of Mac Suitability</li>
                                            <li>Total Cost of Ownership (TCO) Evaluation</li>
                                            <li>Concept Validation and Pilot Implementation</li>
                                            <li>Technical Skill-Building and Enablement</li>
                                            <li>Interactive Experience Centers</li>
                                            <li>Transition and System Integration Support</li>
                                        </ul>
                                    </div>
                                </div>
                  <br>
                  <div class="cta-section-mac-ph">
                    <a href="/contact" class="cta-button animated-tco-btn">Get Started</a>
                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>

<section class="enterprise-offeringsapple">
    <div class="offerings-content">
        
    </div>
    <button class="enterprise-cta-btn" routerLink="/contact">Try Now</button>
</section>

<section class="enterprise-offeringsapple_mob">
    <div class="offerings-content">
        
    </div>
    <button class="enterprise-cta-btn" routerLink="/contact">Try Now</button>
</section>
<br>

<section class="card-section" id="enterprise-solutions">
    <div class="container">
        <div class="row" style="margin-left: 0 !important;">
            <div class="col-lg-12 col-md-12 mb-4" id="mac-startup-accelerator">
                <div class="card bg-image" style="background-image: url('assets/images/mac_accelerator_startup.png');">
                    <div class="card-content"
                        style="display: flex; flex-direction: row; align-items: center; justify-content: center; text-align: left; gap: 2rem;">
                       
                        <h3
                            style="margin-bottom: 0; min-width: 160px; font-size: 2.2rem !important; text-align: center;">
                            Mac Startup Accelerator</h3>
                        <div class="mac-dev-section">
                            <div class="container">
                                <div class="mac-dev-grid">
                                    <div class="mac-dev-col">
                                        <h3>Special Benefits for Startups</h3>
                                        <ul>
                                            <li>Offers for Switching to Mac</li>
                                            <li>Flexible Financing Options</li>
                                        </ul>
                                    </div>
                                    <div class="mac-dev-col">
                                        <h3>Personalised Training Access</h3>
                                        <ul>
                                            <li>Specialized IT Training Programs</li>
                                            <li>End-User Empowerment Solutions</li>
                                            <li>Network of Global Industry Experts</li>
                                        </ul>
                                    </div>
                                    <div class="mac-dev-col">
                                        <h3>Startup Essentials Packages</h3>
                                        <ul>
                                            <li>Onboarding Bundles for New Hires</li>
                                            <li>Professional Headsets and Connectivity Accessories</li>
                                            <li>Comprehensive AppleCare Coverage</li>
                                        </ul>
                                    </div>
                                </div>
                                <br>
                                <div class="cta-section-mac-ph">
                                    <a href="/contact" class="cta-button animated-tco-btn">Get Started</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="card-section" id="enterprise-solutions">
    <div class="container">
        <div class="row" style="margin-left: 0 !important;">
            <section class="col-lg-12 col-md-12 mb-4" id="developer-powerhouse">
                <div class="card bg-image" style="background-image: url('assets/images/macdevph.png');">
                    <div class="card-content"
                        style="display: flex; flex-direction: row; align-items: center; justify-content: center; text-align: left; gap: 2rem;">
                      
                        <h3
                            style="margin-bottom: 0; min-width: 160px; font-size: 2.2rem !important; text-align: center;">
                            Mac Developer's Powerhouse</h3>
                        <div class="mac-dev-section">
                            <div class="container">
                                <div class="mac-dev-grid">
                                    <div class="mac-dev-col">
                                        <h3>Support for Assessment</h3>
                                        <ul>
                                            <li>Technical Assessment Assistance</li>
                                            <li>Network and Compatibility Evaluation</li>
                                        </ul>
                                    </div>
                                    <div class="mac-dev-col">
                                        <h3>PC to Mac Migration </h3>
                                        <ul>
                                            <li>Assistance with Migrating from PC to Mac</li>
                                            <li>Automated Deployment Solutions</li>
                                        </ul>
                                    </div>
                                    <div class="mac-dev-col">
                                        <h3>Customer Success</h3>
                                        <ul>
                                            <li> ⁠Tailored IT Training and End-User Empowerment</li>
                                            <li>Dedicated On-Site or Remote Support Services</li>
                                            <li>Technical Expertise and Developer Resource Assistance</li>
                                        </ul>
                                    </div>
                                </div>
                             
                                <div class="cta-section-mac-ph">
                                    <a href="/devpowerhouse" class="cta-button animated-tco-btn">Learn More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</section>



<section class="service-solutions">
    <div class="container">
        <div class="section-title" style="max-width: 1200px; text-align: left;">
            <h2>Our Services</h2>
            <p>We add value to every aspect of your business by delivering reliable, end-to-end IT solutions designed
                for long-term growth and efficiency. Our services include flexible financing options with tailored
                payment plans, ensuring technology upgrades fit within your budget. We provide comprehensive Apple
                maintenance and support, expert consulting, and hands-on training to empower your teams and maximize
                your tech investment. With scalable solutions and proactive guidance, your enterprise stays agile,
                productive, and ready to meet evolving challenges.</p>
        </div>
        <div class="row" style="margin-left: 0 !important;">
            <div class="col-lg-4 col-md-6 mb-4">
                <div class="solution-card">
                    <div class="card-image">
                        <img src="assets/icons/presales_ser.png" alt="Consulting Services">
                    </div>
                    <div class="card-content">
                        <h3>Apple Pre-Sales Expertise & Proof of Concept</h3>
                        <p>Get expert guidance to choose the right Apple devices for your business and budget—no
                            overspending. Experience Apple in action with live demos and tailored proof of concepts.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 mb-4">
                <div class="solution-card">
                    <div class="card-image">
                        <img src="assets/icons/tradein_serv.png" alt="Support Services">
                    </div>
                    <div class="card-content">
                        <h3>Apple Device Trade-In Program</h3>
                        <p>Easily upgrade with our Apple Trade-In program—get value for old devices toward new ones.
                            Secure, eco-friendly, and seamless for single or fleet replacements.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 mb-4">
                <div class="solution-card">
                    <div class="card-image">
                        <img src="assets/icons/expert_onsite_ser.png" alt="Training Solutions">
                    </div>
                    <div class="card-content">
                        <h3>Apple Services with Expert Onsite Support</h3>
                        <p>Get expert Apple support onsite or remotely—from setup to troubleshooting.
                            Certified engineers ensure smooth performance, tailored to your team's needs.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 mb-4">
                <div class="solution-card">
                    <div class="card-image">
                        <img src="assets/icons/purchase_prog_ser.png" alt="Training Solutions">
                    </div>
                    <div class="card-content">
                        <h3>Tailored Apple Purchase Programs with Financing & Flexible Payment Plans</h3>
                        <p>Every business is unique—so are our Apple purchase plans, with flexible leasing, volume
                            pricing, and financing suited to your needs. Empower your team with the latest Apple
                            technology through predictable costs and easy, stress-free upgrades.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 mb-4">
                <div class="solution-card">
                    <div class="card-image">
                        <img src="assets/icons/seamlessdeploy_serv.png" alt="Training Solutions">
                    </div>
                    <div class="card-content">
                        <h3>Seamless Apple Deployment & Integration</h3>
                        <p>Zero-touch Apple deployment with MDM and Apple Business Manager—fast, secure, and seamless.
                            Ideal for startups to enterprise scale-ups, with expert setup and minimal downtime.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 mb-4">
                <div class="solution-card">
                    <div class="card-image">
                        <img src="assets/icons/support_serv.png" alt="Training Solutions">
                    </div>
                    <div class="card-content">
                        <h3>Comprehensive Apple Maintenance & Support</h3>
                        <p>End-to-end Apple support from certified engineers—onsite or remote.
                            For updates, repairs, and more, we keep your Apple setup running smoothly.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 mb-4">
                <div class="solution-card">
                    <div class="card-image">
                        <img src="assets/icons/training_serv.png" alt="Training Solutions">
                    </div>
                    <div class="card-content">
                        <h3>Custom Apple Training & Enablement</h3>
                        <p>Boost productivity with tailored Apple training for users, creatives, and IT teams.
                            Onsite or online, learn to create, collaborate, and troubleshoot like a pro.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 mb-4">
                <div class="solution-card">
                    <div class="card-image">
                        <img src="assets/icons/ecosystem_serv.png" alt="Training Solutions">
                    </div>
                    <div class="card-content">
                        <h3>Apple Ecosystem Consulting</h3>
                        <p>Align Apple devices, apps, and workflows with your business goals.
                            From planning to deployment, we deliver secure, scalable solutions that work.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 mb-4">
                <div class="solution-card">
                    <div class="card-image">
                        <img src="assets/icons/apple_program_serv.png" alt="Training Solutions">
                    </div>
                    <div class="card-content">
                        <h3>Exclusive Apple Programs</h3>
                        <p>Unlock exclusive Apple benefits for business and education through an authorised partner.
                            Access tools, pricing, and support to grow and achieve more.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="services-section mt-100">
    <div class="services-intro">
        <div class="intro-content">
            <h2>Our Services</h2>
            <p>We add value to every aspect of your business by delivering reliable, end-to-end IT solutions designed
                for long-term growth and efficiency. Our services include flexible financing options with tailored
                payment plans, ensuring technology upgrades fit within your budget. We provide comprehensive Apple
                maintenance and support, expert consulting, and hands-on training to empower your teams and maximize
                your tech investment. With scalable solutions and proactive guidance, your enterprise stays agile,
                productive, and ready to meet evolving challenges.</p>
        </div>
    </div>
    <div class="services-carousel-section bg-color">
        <owl-carousel-o #gridCarousel [options]="gridCarouselOptions" class="grid-carousel">
            <ng-template carouselSlide *ngFor="let item of gridItems">
                <div class="grid-item">
                    <div class="grid-item-image">
                        <img [src]="item.image" [alt]="item.title">
                    </div>
                    <div class="grid-item-content">
                        <h3>{{item.title}}</h3>
                        <p>{{item.description}}</p>
                    </div>
                </div>
            </ng-template>
        </owl-carousel-o>
    </div>
</section>


<section class="pricing-area pt-100 pb-70" id="superior-packages">
    <div class="container">
        <div class="section-title">
            <!-- <span style="font-size: 1.2rem; font-weight: 500;">What We Offer</span> -->
            <h2>Superior Solutions</h2>
            <p class="enterprise-description">Superior Digital offers tiered Apple Enterprise Packages Lite, Pro, and
                Ultra designed to meet the
                evolving needs of growing businesses. From essential Apple device deployment for small teams to fully
                managed, scalable solutions with advanced security, app integration, and multi-location support, there's
                a perfect fit for every stage of your Apple journey.</p>
        </div>

        <div class="row mobile-pricing" style="margin-left: 0 !important;">
            <div class="col-lg-4 col-sm-6" id="superior-lite">
                <div class="single-pricing">
                    <div class="pricing-top-heading">
                        <h3>Superior lite : Starter Solution</h3>
                        <!-- <p>Build A Website</p> -->
                    </div>
                    <p><b style="color: red;">Who It's For</b> Small businesses or startups with limited budgets.</p>
                    <a class="box-btn" routerLink="/contact">Contact Sales</a>
                    <br>
                    <br>
                    <ul>
                        <p style="text-align: left;">Services Included</p>
                        <!-- <br> -->
                        <li><i class="bx bx-badge-check"></i> IT Environment Analysis: Evaluate IT setup for
                            optimization.</li>
                        <li><i class="bx bx-badge-check"></i> CostSmart Advantage: Savings Through Bundled Accessories,
                            Hardware and Software Services (Office 365).</li>
                        <li><i class="bx bx-badge-check"></i> TechSkill Empowerment: Basic Training on Software Services
                            to Empower Users.
                        </li>
                        <li><i class="bx bx-badge-check"></i> GrowthEdge Features: Scalable Deployment Services,
                            Workstation Setup.</li>
                        <li><i class="bx bx-badge-check"></i> CoreCare Support: Remote IT Support Via Email & Phone.
                        </li>

                    </ul>
                    <br>
                    <p style="text-align: left;"><b style="color: red; ">Value Proposition</b> Cost-Effective with
                        Enterprise-Grade features for StartUps, offering Savings and Scalability.</p>
                    <br>
                    <p style="text-align: left;"><b style="color: red; ">Add-Ons</b> Basic Logistic Support.</p>
                    <br>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6" id="superior-pro">
                <div class="single-pricing">
                    <div class="pricing-top-heading">
                        <h3>Superior Pro : Growth Solution</h3>
                        <!-- <p>Build A Website</p> -->
                    </div>
                    <p><b style="color: red;">Who It's For</b> Mid-Sized Businesses & SMBs for Scaling Operations.</p>
                    <a class="box-btn" routerLink="/contact">Contact Sales</a>
                    <br>
                    <br>
                    <ul>
                        <p style="text-align: left;">Services Included</p>
                        <!-- <br> -->
                        <li style="color: red; font-size: 16px;font-weight: bolder;">Includes all features of Superior
                            Lite.</li>
                        <li><i class="bx bx-badge-check"></i> SwiftMac Onboarding: 20-minute Mac deployment via
                            Deployment Services, Tailored for Apple Eco-Systems.</li>
                        <li><i class="bx bx-badge-check"></i> TechMaster Training: Advanced On Demand Training on
                            Software Services, MacOS, iPad Os, iOS Basics for User Adoption.</li>
                        <li><i class="bx bx-badge-check"></i> Demo Devices: Access to Demo Apple units for Internal
                            Testing and Evaluation.</li>
                        <li><i class="bx bx-badge-check"></i> ProAssist Services: End-to-End Logistics Support and
                            Reverse Pickup Facility from User Locations Across India with Transit Insurance.</li>
                        <li><i class="bx bx-badge-check"></i> Additional Services: Warehouse Management, Device Health
                            Checkup & Reporting, Asset Tagging, Asset Management & Reporting, Evaluation and Reporting
                            of Existing Network Facility, Health Check-up Camps.</li>

                    </ul>
                    <br>
                    <p style="text-align: left;"><b style="color: red; ">Value Proposition</b> Developer and
                        Collaboration-Focused solution with Apple-First Deployment, Demo Testing, and Nationwide
                        Logistics—perfect for fast-growing businesses aiming for higher productivity and efficiency.</p>
                    <br>
                    <p style="text-align: left;"><b style="color: red; ">Add-Ons</b> Demo of Accessories and Devices to
                        Facilitate Apple Eco-System. Remote Diagnose Support & Reporting.</p>
                    <br>
                </div>
                <!-- <div class="single-pricing">
                    <div class="pricing-top-heading">
                        <h3>Superior Pro : Growth Solution</h3>
                    </div>
                    <a class="box-btn" routerLink="/contact">Contact Sales</a>
                    <br>
                    <ul>
                        <p>Features</p>
                        <li style="color: red; font-size: 16px;font-weight: bolder;">Includes all features of Superior
                            Lite.</li>
                        <li><i class="bx bx-badge-check"></i>Zero-touch deployment with advanced ABM and MDM
                            configurations.</li>
                        <li><i class="bx bx-badge-check"></i>Integration with enterprise apps (e.g., Microsoft 365,
                            Google Workspace).</li>
                        <li><i class="bx bx-badge-check"></i>Enhanced security (VPN, single sign-on, conditional
                            access).</li>
                        <li><i class="bx bx-badge-check"></i>AppleCare+ for Business and extended warranty options.</li>
                        <li><i class="bx bx-badge-check"></i>In-person or virtual training on macOS, iOS, and iPadOS,
                            plus biannual IT reviews</li>
                        <li><i class="bx bx-badge-check"></i>Dedicated account manager.</li>
                        <li><i class="bx bx-badge-check"></i>Asset tagging support.</li>
                        <li><i class="bx bx-badge-check"></i>Logistics support, reverse pickup facility from user
                            locations across India with transit insurance.</li>
                    </ul>
                    <br>
                    <ul>
                        <p>Benefits</p>
                        <li><i class="bx bx-badge-check"></i> Streamlines complex deployments for hybrid environments,
                            supporting 100–500 devices with compliance, logistics, and asset management.</li>
                    </ul>
                    <strong class="popular">Popular</strong>
                </div> -->
            </div>

            <div class="col-lg-4 col-sm-6 offset-sm-3 offset-lg-0" id="superior-ultra">
                <div class="single-pricing">
                    <div class="pricing-top-heading">
                        <h3>Superior Ultra : Enterprise Solution</h3>
                        <!-- <p>Build A Website</p> -->
                    </div>
                    <p><b style="color: red;">Who It's For</b> Large Enterprises for Complex Operations.</p>
                    <a class="box-btn" routerLink="/contact">Contact Sales</a>
                    <br>
                    <br>
                    <ul>
                        <p style="text-align: left;">Services Included</p>
                        <!-- <br> -->
                        <li style="color: red; font-size: 16px;font-weight: bolder;">Includes all features of Superior
                            Pro.</li>
                        <li><i class="bx bx-badge-check"></i> MacFit Assessment: Comprehensive Mac deployment evaluation
                            via IT Environment Analysis.</li>
                        <li><i class="bx bx-badge-check"></i> ValueMax Analytics: TCO/TEI analysis for Apple ecosystems.
                        </li>
                        <li><i class="bx bx-badge-check"></i> SeamlessSync Deployment: Custom Deployment Services with
                            Rapid Setup and Integration</li>
                        <li><i class="bx bx-badge-check"></i> CycleWorks Management: End-to-End Device Management. IT
                            Life Cycle Management, Buy Back Options.</li>
                        <li><i class="bx bx-badge-check"></i> FlexPay Solutions: Flexible Financing Options for
                            Hardware/Software to Enhance Affordability.</li>
                        <li><i class="bx bx-badge-check"></i> Buy Portal: Discounted Apple Device Purchases for
                            Employees.</li>
                        <li><i class="bx bx-badge-check"></i> EliteTech Support: Onsite Device Support by Apple
                            Certified Technician Across 25 Locations in India and Reporting Facility on Reverse Pickup
                        </li>
                        <li><i class="bx bx-badge-check"></i> SecureGuard Insurance: Theft Coverage During
                            Transit/Storage.</li>
                        <li><i class="bx bx-badge-check"></i> Additional Services: Training on Mac OS, iOS, and iPadOS
                            (hands-on workshops).</li>
                    </ul>
                    <br>
                    <p style="text-align: left;"><b style="color: red; ">Value Proposition</b> All-in-One Enterprise
                        Solution with Apple Expertise, Nationwide
                        Support, and Customized Financial and Insurance Services.</p>
                    <br>
                    <p style="text-align: left;"><b style="color: red; ">Add-Ons</b> On Demand Resident Engineer.</p>
                    <br>
                </div>
                <!-- <div class="single-pricing">
                    <div class="pricing-top-heading">
                        <h3>Superior Ultra : Enterprise Solution</h3>
                    </div>
                    <a class="box-btn" routerLink="/contact">Contact Sales</a>
                    <br>
                    <ul>
                        <p>Features</p>
                        <li style="color: red;font-size: 16px;font-weight: bolder;">Includes all features of Superior
                            Pro</li>
                        <li><i class="bx bx-badge-check"></i> Fully customized ABM and MDM deployment with role-based
                            profiles.</li>
                        <li><i class="bx bx-badge-check"></i> Custom app integration or development via Superior's
                            network.</li>
                        <li><i class="bx bx-badge-check"></i> Custom app integration or development via Superior's
                            network.</li>
                        <li><i class="bx bx-badge-check"></i> On-site deployment support across multiple India
                            locations.</li>
                        <li><i class="bx bx-badge-check"></i> Comprehensive training on macOS, iOS, and iPadOS, plus
                            ongoing workshops.</li>
                        <li><i class="bx bx-badge-check"></i> Premium 24/7 support with SLA-backed response times and
                            lifecycle management.</li>
                        <li><i class="bx bx-badge-check"></i> Warehousing support.</li>
                        <li><i class="bx bx-badge-check"></i> Apple Certified Technician diagnose and reporting facility
                            on reverse pickup.</li>
                        <li><i class="bx bx-badge-check"></i> Theft Insurance</li>
                    </ul>
                    <br>
                    <ul>
                        <p>Benefits</p>
                        <li><i class="bx bx-badge-check"></i> Delivers enterprise-grade scalability, security, and
                            comprehensive logistics for 1,000+ devices across regions.</li>
                    </ul>
                </div> -->
            </div>
        </div>
    </div>
</section>

<section class="enterprise-solutions mt-100 cta-section">
    <div class="container2">
        <div class="row" style="margin-left: 0px !important">
            <div class="col-lg-12 col-md-12 mb-4">
                <div class="card bg-image"
                    style="background-image: url('assets/images/tco_img_new.png');position: relative;">
                    <div class="card-content appleenterprise-card">
                        <div class="content-section">
                            <h2 style="margin-bottom: 1rem; font-weight: bold; color: #fff;"
                                class="tco-title responsive-title">Total Cost of
                                Ownership (TCO)</h2>
                            <p class="tco-description">Apple Macintosh may have a higher initial
                                investment compared to Windows PCs, but they offer a significantly lower Total Cost of
                                Ownership (TCO) over time thanks to fewer support issues, longer hardware longevity, and
                                higher resale value. Enterprises benefit from reduced IT overhead, improved employee
                                satisfaction, and enhanced security, with macOS updates and Apple's suite of
                                productivity and creativity apps like Preview, Pages, Numbers, Keynote and
                                iMovie provided at no additional cost. Adopting Macs helps organisations streamline
                                operations, empower teams, and gain long-term value from their technology investments.
                            </p>
                            <a href="/tco" class="cta-button animated-tco-btn" style="float: inline-end;">Know Your
                                TCO</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>